import React from "react";
import { Link } from "react-router-dom";
import "../CSS/Footer.css";
import { FaYoutube, FaTwitter, FaInstagram, FaFacebook } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
      
        <div className="footer-section">
          <h2>
            <Link to="/" className="footer-logo-text">AmphiGreen</Link> 
          </h2>
          <p>Your trusted partner for a sustainable and innovative tomorrow.</p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/leadership">LeaderShip</Link></li>
            <li><Link to="/alliances">Alliances</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-links">
            <a 
              href="https://www.youtube.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </a>
            <a 
              href="https://twitter.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a 
              href="https://www.facebook.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
            <a 
              href="https://www.instagram.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>📍 New Delhi, India</p>
          <p>📞 +91 11 1234 5678</p>
          <p>✉️ info@amphigreen.com</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AmphiGreen. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
